import React from 'react';
import { Upload, Form } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import notification from '../../../elements/lib/NotificationWrapper';
import { Translation, getI18n } from 'react-i18next';

// upload criteria
const fileTypesImage = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
};

const fileSizeLimit = 1024 * 1024 * 6;

const MediaUploadModule = ({ form, uploadedMedia, setUploadedMedia }) => {
  const propsMedia = {
    multiple: false,
    onChange(info) {
      const fileList = info.fileList;
      setUploadedMedia(fileList);

      form.setFields([
        {
          name: ['media'],
          media: fileList,
        },
      ]);

      form.validateFields([['media']]);
    },
    beforeUpload(file) {
      const isSupportedFileType = Object.keys(fileTypesImage).includes(
        file.type
      );
      if (!isSupportedFileType) {
        notification.error(
          getI18n().t('learning_admin_form_input_media_file_types')
        );
        setUploadedMedia(null);
        return Upload.LIST_IGNORE;
      }
      const isUnderFileSizeLimit = file.size < fileSizeLimit;
      if (!isUnderFileSizeLimit) {
        notification.error(
          getI18n().t('learning_admin_form_input_image_file_size_limit')
        );
        setUploadedMedia(null);
        return Upload.LIST_IGNORE;
      }
      return false;
    },
  };

  const handleRemove = () => {
    setUploadedMedia(null);

    form.setFields([
      {
        name: ['media'],
        media: undefined,
      },
    ]);

    form.validateFields(['media']);
  };

  return (
    <Translation>
      {(t) => (
        <div className='form-group'>
          <Form.Item
            name={'media'}
            rules={[
              { required: true, message: 'Missing data for required field.' },
            ]}
          >
            {uploadedMedia === null || uploadedMedia.length === 0 ? (
              <Upload.Dragger {...propsMedia}>
                <p className='ant-upload-drag-icon'>
                  <InboxOutlined />
                </p>
                <p className='ant-upload-text'>
                  {t('learning_admin_form_input_image_drag_and_drop_upload')}
                </p>
                <p className='ant-upload-hint'>
                  {t('learning_admin_form_input_image_drag_and_drop_types')}
                </p>
              </Upload.Dragger>
            ) : (
              <Upload
                className='upload-file'
                fileList={uploadedMedia}
                listType='picture'
                multiple={false}
                onRemove={handleRemove}
              />
            )}
          </Form.Item>
        </div>
      )}
    </Translation>
  );
};

export default MediaUploadModule;
